export interface MissionsResponse {
    title: string;
    link: string;
    messages: Messages;
    missions?: Mission[];
    noData?: boolean;
}

export interface Messages {
    missionNumber: string;
    linkTitle: string;
    details: string;
    noMissionsText?: string;
    noDataText?: string;
    weekNumber?: string;
}

export interface Mission {
    equipmentAlias?: string;
    equipmentName: string;
    equipmentNumber: string;
    missionNumber: string;
    assignmentType: string;
    date: string | null;
    sisCaseId: string;
    status:
        | "MISSION_CREATED"
        | "MISSION_PLANNED"
        | "MISSION_PROPOSED"
        | "MISSION_CONFIRMED"
        | "MISSION_TECHNICIAN_SCHEDULED"
        | "MISSION_COMPLETED";
    link: string;
}
